import ReactApexChart from "react-apexcharts";
import React from "react";




class ApexChart extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
      
        series: [{
          name: 'Income',
          type: this.props.graphType,
          data: this.props.db
        }, {
          name: 'Cashflow',
          type: "column",
          data: this.props.db2
        },
        //  {
        //   name: 'Revenue',
        //   type: 'line',
        //   data: [20, 29, 37, 36, 44, 45, 50, 58]
        // }
    ],
        options: {
        //   chart: {
        //     height: 350,
        //     type:"line",
        //     stacked: false
        //   },
        //   dataLabels: {
        //     enabled: false
        //   },
          stroke: {
            width: [1, 1, 3]
          },
        //   title: {
        //     text: 'XYZ - Stock Analysis (2009 - 2016)',
        //     align: 'left',
        //     offsetX: 110
        //   },
          xaxis: {
            categories: this.props.labels,
            
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#008FFB'
              },
              labels: {
                style: {
                  colors: '#008FFB',
                }
              },
            //   title: {
            //     text: "Income (thousand crores)",
            //     style: {
            //       color: '#008FFB',
            //     }
            //   },
            //   tooltip: {
            //     enabled: true
            //   }
            },
            {
              seriesName: 'Income',
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#00E396'
              },
              labels: {
                style: {
                  colors: '#00E396',
                 
                }
              },
            //   title: {
            //     text: "Operating Cashflow (thousand crores)",
            //     style: {
            //       color: '#00E396',
            //     }
            //   },
            },
             {
              seriesName: 'Revenue',
              opposite: true,
              show:false,
              axisTicks: {
                show: true,
              },
            //   axisBorder: {
            //     show: true,
            //     color: '#FEB019'
            //   },
              labels: {
                style: {
                  colors: '#FEB019',
                },
              },
            //   title: {
            //     text: "Revenue (thousand crores)",
            //     style: {
            //       color: '#FEB019',
            //     }
            //   }
            },
          ],
          tooltip: {
            fixed: {
              enabled: true,
              position: 'top', // topRight, topLeft, bottomRight, bottomLeft
              offsetY: 30,
              offsetX: 60
            },
          },
          legend: {
            horizontalAlign: 'center',
            offsetX: 40
          }
        },
      
      
      };
    }

  

    render() {
      return (
        

  <div id="chart">
<ReactApexChart options={this.state.options} series={this.state.series} type="line" height={160} />
</div>
      );
    }
}
export default ApexChart